import styled from 'styled-components'
import useClickOutside from '../../core/hooks/useClickOutside'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef } from 'react'
import { variants } from '../../core/utils/common'
import Text from '../../core/utils/Text'
import XIcon from '../icons/XIcon'
import ReactDOM from 'react-dom'


const ModalLayout = ({
  width,
  children,
  onClose,
  open,
  isStatic = false,
  noBg = false,
  padding,
  title = undefined
}) => {
  const modalRef = useRef()
  const togglerRef = useRef()
  useClickOutside(modalRef, togglerRef, () => {
    if (!isStatic) onClose()
  })

  const modalRoot = document.getElementById('modal-root')



  useEffect(() => {
    // Lock body scroll when modal is open
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => document.body.style.overflow = 'auto'

  }, [open])


  return ReactDOM.createPortal(
    <>
      {open ? (
        <Body>
          <AnimatePresence exitBeforeEnter>
            {open && (
              <Wrapper
                noBg={noBg}
                ref={modalRef}
                variants={variants}
                initial='out'
                animate='in'
                exit='out'
                width={width}
              >
                {title &&
                  <Header>
                    <Text tid={title} className='mx-auto text-xl' />
                  </Header>
                }
                <Content padding={padding}>
                  {children}
                </Content>
              </Wrapper>
            )}
          </AnimatePresence>
        </Body>
      ) : null}
    </>,
    modalRoot
  )
}

const Body = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	width: 100%;
	height: 100%;
  background-color: ${props => props.theme.modalBg}70;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
    font-family: ${(props) => (props.theme.english ? 'Metrophobic' : 'Kalameh')};
`

const Wrapper = styled(motion.div)`
	width: 100%;
	max-width: ${(props) => props.width};
	background-color: ${(props) => (props.noBg ? 'transparent' : props.theme.modalBg)};
	border-radius: 16px;
		z-index: 9999;


	@media screen and (max-width: 480px) {
		padding: ${(props) => props.padding || '30px 20px'};
		width: ${(props) => props.width || '70%'};
		margin: 0 8px;
	}
`

const Content = styled.div`
	padding: ${(props) => props.padding || '12px'};
  border-radius: 16px;
`

const Header = styled.div`
  width: 100%;
  border-radius: 16px 16px 0 0;
	background-color: ${(props) => (props.noBg ? 'transparent' : props.theme.modalBg)};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
`

export default ModalLayout
